<div class="row">
  <div class="col-md-12 col-lg-12">
    <ul class="nav flex-row nav-pills" id="myTab" role="tablist">
      <li class="nav-item" *ngIf="context.persona !== 'ADMIN'">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'myAccount'}"
          (click)="setActiveTab('myAccount')" id="info-tab" role="tab" aria-controls="myAccount">
          <i class='bx bx-credit-card icon'></i>
          <span class="align-middle me-1">My Account</span>
        </a>
      </li>
      <li class="nav-item" *ngIf="context.persona !== 'ADMIN'">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'address'}"
          (click)="setActiveTab('address')" id="address" role="tab" aria-controls="address">
          <i class='bx bx-map'></i>
          <span class="align-middle me-2">Address</span>
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="javascript:;" [ngClass]="{active: activeTab === 'change-password'}"
          (click)="setActiveTab('change-password')" id="change-password" role="tab" aria-controls="change-password">
          <i class='bx bx-lock'></i>
          <span class="align-middle me-2">Password</span>
        </a>
      </li>
    </ul>
    <hr>
    <ng-container *ngIf="activeTab === 'myAccount'">
      <app-employee-profile
        *ngIf="employee?.employeeData?.id && context.persona !== 'ADMIN' && context.persona !== 'CLIENT'"
        [employee]="employee" (passEntry)="getEmployeeProfileInfo()"></app-employee-profile>
      <app-company-profile [company]="company" *ngIf="context.persona == 'CLIENT'" (passEntry)="getCompanyProfileInfo()"></app-company-profile>
    </ng-container>
    <ng-container *ngIf="activeTab === 'address'">
      <ng-container *ngIf="context.persona === 'CLIENT'">
        <app-address class="card"  *ngIf="company?.id" [refId]="company?.id" ref="COMPANY" [onLoad]="onLoad"></app-address>
      </ng-container>
      <ng-container *ngIf="context.persona !== 'CLIENT'">
        <app-address class="card" *ngIf="employee?.employeeData?.id" [refId]="employee.employeeData.id" ref="EMPLOYEE" [onLoad]="onLoad"></app-address>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="activeTab === 'change-password'">
      <ng-container *ngIf="context.persona !== 'CLIENT'">
        <app-change-password [employee]="employee"></app-change-password>
      </ng-container>
      <ng-container *ngIf="context.persona === 'CLIENT'">
        <app-change-password [company]="company"></app-change-password>
      </ng-container>
    </ng-container>
  </div>
</div>